import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

// Instance axios pour le dashboard
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const dashboardService = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  exportPdf: async () => {
    const response = await api.get('/dashboard/export/pdf', {
      responseType: 'blob',
    });
    return response.data;
  },

  exportExcel: async () => {
    const response = await api.get('/dashboard/export/excel', {
      responseType: 'blob',
    });
    return response.data;
  },
};

export default dashboardService;

